<template>
  <div class="container-fluid default-dashboard pt-2">
    <div class="col-12">
      <div class="row">
        <div class="col-12 col-md-3">
          <Card1 colClass="col-12" cardClass="card" cardhaderClass="card-no-border pb-0" header="true" title="Rank Team"
            headerTop="true" down="false" cardbodyClass="top-user pt-2" haderTitle="true">
            <ul>
              <li class="d-flex align-items-center justify-content-between gap-2" v-for="(item, index) in teamDivisi"
                :key="index">
                <div class="d-flex gap-2 py-1">
                  <!-- <div class="flex-shrink-0 comman-round">
                    <span class="text-white rounded-circle d-flex align-items-center justify-content-center">{{
                      item.divisi_team_name }}</span>
                  </div> -->
                  <div>
                    <a href="#">
                      <h6>{{ item.divisi_team_name }}</h6>
                    </a>
                    <p>Order: {{ formatSeparator(item.total_orders) }} ({{
                      formatSeparator(item.total_qty) }})</p>
                  </div>
                </div>
                <span>{{ formatCurrency(item.grand_total) }}</span>
              </li>
            </ul>
          </Card1>
        </div>
        <div class="col-md-9">
          <div class="row general-widget">
            <Card1 colClass="col-sm-6 col-xl-3 box-col-6" cardClass="card widget-1" v-for="(item, index) in widgets"
              :key="index">
              <div class="widget-content">
                <div class="widget-round " :class="item.class">
                  <div class="bg-round">
                    <svg class="svg-fill">
                      <use :xlink:href="`/icon-sprite.svg#${item.svg1}`"></use>
                    </svg>
                    <svg class="half-circle svg-fill">
                      <use :xlink:href="`/icon-sprite.svg#${item.svg2}`"></use>
                    </svg>
                  </div>
                </div>
                <div>
                  <h4>{{ formatCurrency(item.number) }}</h4><span class="f-light">{{ item.title }}</span>
                </div>
              </div>
            </Card1>
          </div>
          <div class="row">
            <Card1 colClass="col-xxl-12 col-xl-12 proorder-xxl-12 col-lg-12 col-md-12 box-col-12" cardClass="card"
              cardHeaderClass="card-no-border pb-0" header="true" :title="`History Order ${params.divisi_name}`"
              cardbodyClass="transaction-history pt-0">
              <div class="table-responsive theme-scrollbar">
                <DataTable :headers="headers" :items="orderHistory" :loading="loading" :total="total" :params="params"
                  @update:params="updateParams">
                  <template #item.transaction_date="{ item }" style="white-space: nowrap;word-wrap: break-word;">
                    {{ formatDateTime(item.transaction_date) }}
                  </template>
                  <template #item.divisi="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                    item.divisi_team.name }}</template>
                  <template #item.customer="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                    item.customer.name }}</template>
                  <template #item.qty_total="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                    item.qty_total }}</template>
                  <template #item.grand_total="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                    formatCurrency(item.grand_total) }}</template>
                </DataTable>
              </div>
            </Card1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted, defineAsyncComponent } from 'vue'
import DataTable from '@/components/table/DatatableDateRange.vue'
import { toast } from 'vue3-toastify'
import { useSessionStore } from '@/store/session';
const session = useSessionStore()
const teamDivisi = ref<any>([])
import * as sales from "@/api/services/SalesRequest";
const widgets = ref([
  {
    class: "danger",
    svg1: "cart",
    svg2: "halfcircle",
    number: "0",
    title: "Order",
    font: "font-danger",
    icon: "icon-arrow-up",
    total: "+50%"
  },
  {
    class: "primary",
    svg1: "tag",
    svg2: "halfcircle",
    number: "0",
    title: "Quantity",
    font: "font-primary",
    icon: "icon-arrow-up",
    total: "+70%"
  },
  {
    class: "secondary",
    svg1: "return-box",
    svg2: "halfcircle",
    number: "0",
    title: "Delivery",
    font: "font-secondary",
    icon: "icon-arrow-down",
    total: "-20%"
  },
  {
    class: "success",
    svg1: "rate",
    svg2: "halfcircle",
    number: "0",
    title: "Omset",
    font: "font-success",
    icon: "icon-arrow-up",
    total: "+70%"
  }
])
const Card1 = defineAsyncComponent(() => import("@/components/common/card/CardData1.vue"))

const headers = [
  { text: 'Order No', value: 'code' },
  { text: 'Transaction Date', value: 'transaction_date' },
  { text: 'Divisi', value: 'divisi_team_name' },
  { text: 'Customer', value: 'customer_name' },
  { text: 'Payment', value: 'payment' },
  { text: 'Sales', value: 'sales_name' },
  { text: 'Status', value: 'order_status' },
  { text: 'QTY', value: 'qty_total' },
  { text: 'Grand Total', value: 'grand_total' },
]

const orderHistory = ref<any>([])
const loading = ref(false)
const total = ref(0)

const params = reactive<DataTableParams>({
  page: 1,
  size: 10,
  search: '',
  divisi_id: session.divisionOptions().find(d => d.name === session.getUser().divisi)?.ID,
  divisi_name: session.divisionOptions().find(d => d.name === session.getUser().divisi)?.name,

})

const updateParams = (newParams: Partial<DataTableParams>) => {
  Object.assign(params, newParams)
  fetchOrder()
  fetchSalesDashboardWidget()
  fetchSalesDashboardTopDivisi()
}

function formatDateTime(dateString: string): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
}
function formatCurrency(value: number) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0
  }).format(value);
}

function formatSeparator(value: number): string {
  return new Intl.NumberFormat('id-ID', {
    style: 'decimal',
    minimumFractionDigits: 0
  }).format(value);
}

const fetchSalesDashboardTopDivisi = async () => {
  loading.value = true
  try {
    // Simulate API delay
    const paramstemp = session.getUser().role == "SALES" ? { ...params, email: session.getUser().email } : params
    await sales.postRequest("/dashboard/sales-team-rank", paramstemp).then((response) => {
      if (response.data) {
        teamDivisi.value = response.data
      }
    });

  } catch (error) {
    toast.error('Failed to fetch warehouse delivery')
  }
  loading.value = false
}

const fetchSalesDashboardWidget = async () => {
  loading.value = true
  try {
    // Simulate API delay
    const paramstemp = session.getUser().role == "SALES" ? { ...params, email: session.getUser().email } : params
    await sales.postRequest("/dashboard/sales-widget", paramstemp).then((response) => {
      if (response.data) {
        response.data.forEach((item: any) => {
          widgets.value[0].number = item.order_paid
          widgets.value[1].number = item.order_quantity
          widgets.value[2].number = item.order_delivery
          widgets.value[3].number = item.order_omset
        })
      }
    });

  } catch (error) {
    toast.error('Failed to fetch warehouse delivery')
  }
  loading.value = false
}

async function fetchOrder() {
  loading.value = true
  const paramstemp = session.getUser().role == "SALES" ? { ...params, email: session.getUser().email } : params
  await sales.postRequest("/order/list", paramstemp).then((res) => {
    if (res.status == 200 && res.data) {
      orderHistory.value = res.data
      total.value = res.total
    } else {
      orderHistory.value = []
      total.value = 0
    }
  })
  loading.value = false
}

onMounted(() => {

})
</script>